import { Box, Chip, Typography } from '@mui/material'
import CardWithSpace from '../../../components/Cards/CardWithSpace/index.jsx'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import TitleWithInfo from '../../../components/Cards/helpers/TitleWithInfo.jsx'

const ServiceProvider = ({ ssoSettingsSnapshot }) => {
  const { t } = UseTranslation()

  return (
    <CardWithSpace customStyles={styles.detailsCardShellSpBelow}>
      <Box sx={styles.detailsHeaderRow}>
        <Box sx={styles.detailsHeaderTitles}>
          <Typography component="h2" sx={styles.detailsTitle}>
            {t?.SsoServiceProviderTitle}
          </Typography>
          <Typography sx={styles.detailsSubtitle}>
            {t?.SsoServiceProviderSubtitle}
          </Typography>
        </Box>
        <Chip label={t?.SsoSaml2Badge} size="small" sx={styles.samlHeaderBadge} />
      </Box>
      <Box sx={styles.detailsBody}>
        <TitleWithInfo
          title={t?.SsoSpBaseUrl}
          info={ssoSettingsSnapshot.sp_base_url}
          customStyle={styles.detailRow}
        />
        <TitleWithInfo
          title={t?.SsoSpEntityId}
          info={ssoSettingsSnapshot.sp_entity_id}
          customStyle={styles.detailRow}
        />
      </Box>
    </CardWithSpace>
  )
}

const cardShellBase = {
  border: '1px solid #e8eaed',
  borderRadius: '12px',
  boxShadow: 'none',
  marginBottom: 0,
  overflow: 'hidden',
  padding: 0,
}

const styles = {
  detailsCardShellSpBelow: {
    ...cardShellBase,
    mt: 2,
  },
  detailsHeaderRow: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'flex-start' },
    justifyContent: 'flex-start',
    gap: { xs: 1.5, sm: 2 },
    px: { xs: 2.5, sm: 3 },
    pt: { xs: 2.5, sm: 3 },
    pb: { xs: 2, sm: 2.5 },
    borderBottom: '1px solid #ebecef',
  },
  detailsHeaderTitles: {
    flex: 1,
    minWidth: 0,
  },
  detailsTitle: {
    fontWeight: 700,
    fontSize: { xs: '1rem', sm: '1.0625rem' },
    color: '#1b2559',
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
  },
  detailsSubtitle: {
    mt: 0.75,
    fontSize: { xs: '0.75rem', sm: '0.8125rem' },
    fontWeight: 400,
    color: '#92929d',
    lineHeight: 1.45,
    maxWidth: '520px',
  },
  samlHeaderBadge: {
    height: 28,
    flexShrink: 0,
    fontWeight: 600,
    fontSize: '0.75rem',
    color: '#29CC8B',
    backgroundColor: 'rgba(41, 204, 139, 0.12)',
    border: '1px solid #29CC8B',
    borderRadius: '999px',
    '& .MuiChip-label': { px: 1.25 },
  },
  detailsBody: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    px: { xs: 2.5, sm: 3 },
    py: { xs: 2, sm: 2.25 },
    borderBottom: '1px solid #ebecef',
    marginRight: '0px !important',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(29, 158, 117, 0.05)',
    },
    ' & h5': {
      flexShrink: 0,
      width: { xs: '100px', sm: '300px' },
      minWidth: { xs: '100px', sm: '300px' },
      maxWidth: { xs: '100px', sm: '300px' },
      fontSize: { xs: '0.8125rem', sm: '0.875rem' },
      fontWeight: 400,
      color: '#92929d',
      lineHeight: 1.4,
    },
    ' & h6': {
      textAlign: { xs: 'right', sm: 'left' },
      width: { xs: '100px', sm: 'unset' },
      fontSize: '14px',
      flex: 1,
      textTransform: 'none',
      wordBreak: 'break-word',
    },
  },
  detailRowLast: {
    borderBottom: 'none',
  },
}

export default ServiceProvider
